import moment from 'moment'
import * as Effects from 'redux-saga/effects'
import {FormateContractPayment, calculateDateNew, formatter, parseFee} from '../../../../utils'
import {
  BUSSINESS,
  CLONEDATA,
  CONTRACTSTATUS,
  CURRENTTAB,
  FORMACTIVED,
  NEWTAB,
  OFFERFEECODE,
  PACKAGES,
  PRODUCTINFORS,
  PRODUCTVALIDATION,
} from '../../healthInsurance/redux/action'
import {
  ADDITIONALID,
  ActionTypes,
  BENEFITINFO,
  CARGOPACKAGEINSUREDFEE,
  EXTENSIONCODE,
  IUPDATECURRENCYSTATE,
  LOCAINSUREDFILTER,
  LOCATIONLIST,
  MARINEPACKAGECODE,
  PACKAGEBENEFITS,
  PAYMENTTIMEDAY,
  PAYMENTTIMEDAYID,
  PRODUCTINSURANCEPLAN,
  PROPERTYADDRESS,
  PROPERTYBYID,
  PROPERTYINFO,
  PROPERTYUPDATEID,
  REDUXINITIALSTATE,
  RISKBENFITDETAILS,
  UPDATEBENFIT,
} from './action'
import {
  ProductInitialStateModel,
  formCargoListInsuredState,
  formCargoOfferFeeState,
  formMarineInsuredState,
  formMarineOfferFeeState,
  formProductContractState,
  formProductHouseInsuredState,
  formProductInsurancePlanState,
  formPropertyLocaInsuredState,
  formPropertyOfferFeeState,
  formTechnicalListState,
  formTechnicalOfferFeeState,
  productInitialState,
  formMicroOfferFeeState,
  formMicroInsuredState,
} from './model'
import {FEEANDTAX} from '../../MotoInsurance/redux/actions'
import {INSUREDFILTER} from '../../AutoInsurance/redux/action'
import {
  getHouseInsuredById,
  getListHouseInsured,
  step2GetContractPackageCargoByCode,
  step2GetContractPackageMarineByCode,
  step4GetObjectInsuredById,
  step3GetObjectInsuredMarineList,
  step3GetObjectInsuredMarineByID,
  step2GetObjectInsuredPropertyList,
  step2GetObjectInsuredLocationByID,
  step3GetObjectInsuredMicroList,
  step2GetContractPackageMicroByCode,
  step3GetObjectInsuredMicroByID,
  getListContractByAddress,
} from '../apis/index'
import {step2GetContractExtraData, step4GetContractByID} from '../../healthInsurance/apis'
import {InsurancePlanModel} from '../../healthInsurance/model/InsurancePlanModel'
import {
  ListPropertyPackageBenefitModel,
  ListPropertyPackageBusinessInterruptionModel,
  ListPropertyPackageExtensionModel,
  ListPropertyPackageRiskBenefitDto,
  ListPropertyPackageRiskBenefitModel,
  ListPropertyPackageRiskModel,
  PropertyOfferFeeModel,
  PropertyPackageBenefitModel,
  PropertyPackageExtensionModel,
  PropertyPackageRiskBenefitDto,
} from './model/IProperty'

const call: any = Effects.call
const takeLatest = Effects.takeLatest
const put = Effects.put

export const actions = {
  addNewTab: (tab: NEWTAB) => ({type: 'ADDNEWPRODUCT', payload: tab}),
  modifyTab: (tab: CURRENTTAB) => ({type: 'MODIFYTABPRODUCT', payload: tab}),
  activeFormProduct: (active: FORMACTIVED) => ({type: 'ACTIVEFORMPRODUCT', payload: active}),
  removeTab: (tab: string) => ({type: 'REMOVETABPRODUCT', payload: tab}),
  addProductInfos: (data: PRODUCTINFORS) => ({type: 'ADDPRODUCTINFORS', payload: data}),
  updateProductContractStatus: (data: CONTRACTSTATUS) => ({
    type: 'UPDATEPRODUCTCONTRACTSTATUS',
    payload: data,
  }),
  saveProductPackageInsurances: (data: PACKAGES) => ({
    type: 'SAVEPRODUCTPACKAGEINSURANCES',
    payload: data,
  }),
  updateProductFeeTax: (data: FEEANDTAX) => ({
    type: 'UPDATEPRODUCTFEETAX',
    payload: data,
  }),
  updatePackageBenefits: (data: PACKAGEBENEFITS) => ({
    type: 'UPDATEPACKAGEBENEFITS',
    payload: data,
  }),
  clearForm: (data: CLONEDATA) => ({type: 'CLEARFORM', payload: data}),
  resetClearState: (data: CARGOPACKAGEINSUREDFEE) => ({type: 'RESETCLEARFORM', payload: data}),
  cloneForm: (data: CLONEDATA) => ({type: 'CLONEFORM', payload: data}),
  getHouseInsuredById: (data: any) => ({
    type: 'GETHOUSEINSUREDBYID',
    payload: data,
  }),
  saveHouseInsured: (data: any) => ({
    type: 'SAVEHOUSEINSURED',
    payload: data,
  }),
  getListHouseInsured: (data: INSUREDFILTER) => ({
    type: 'GETLISTHOUSEINSURED',
    payload: data,
  }),
  saveListHouseInsured: (data: any) => ({
    type: 'SAVELISTHOUSEINSURED',
    payload: data,
  }),
  validateFormProduct: (data: PRODUCTVALIDATION) => ({type: 'VALIDATEFORMPRODUCT', payload: data}),
  getHouseContractStep4ById: (data: any) => ({type: 'GETHOUSECONTRACTSTEP4BYID', payload: data}),
  saveHouseContractStep4ById: (data: any) => ({
    type: 'SAVEHOUSECONTRACTSTEP4BYID',
    payload: data,
  }),
  updateReduxInitialState: (data: REDUXINITIALSTATE) => ({
    type: 'UPDATEREDUXINITIALSTATE',
    payload: data,
  }),
  updateBussinessFormProduct: (data: BUSSINESS) => ({
    type: 'UPDATEBUSSINESSFORMPRODUCT',
    payload: data,
  }),
  saveProductInsurancePlan: (data: PRODUCTINSURANCEPLAN) => ({
    type: 'SAVEPRODUCTINSURANCEPLAN',
    payload: data,
  }),
  deleteBenefitInfo: (data: any) => ({
    type: 'DELETEBENEFITINFO',
    payload: data,
  }),
  saveCargoOfferFee: (data: any) => ({
    type: 'SAVECARGOOFFERFEE',
    payload: data,
  }),
  addBenefitInfo: (data: BENEFITINFO) => ({type: 'ADDBENEFITINFO', payload: data}),
  updateBenefitInfo: (data: any) => ({type: 'UPDATEBENEFITINFO', payload: data}),
  savePackageExtensions: (data: PACKAGES) => ({
    type: 'SAVEPACKAGEEXTENSIONS',
    payload: data,
  }),
  getDataFormCargoOfferFeeByCode: (data: OFFERFEECODE) => ({
    type: 'GETDATAFORMCARGOOFFERFEEBYCODE',
    payload: data,
  }),
  saveDataFormCargoOfferFee: (data: any) => ({type: 'SAVEDATAFORMCARGOOFFERFEE', payload: data}),
  deleteExtensionInfo: (data: EXTENSIONCODE) => ({
    type: 'DELETEEXTENSIONINFO',
    payload: data,
  }),
  savePackageBenefits: (data: UPDATEBENFIT) => ({
    type: 'SAVEPACKAGEBENEFITS',
    payload: data,
  }),
  savePackageTemplate: (data: PACKAGES) => ({
    type: 'SAVEPACKAGETEMPLATE',
    payload: data,
  }),
  updateCargoPackageInsuredFee: (data: CARGOPACKAGEINSUREDFEE) => ({
    type: 'UPDATECARGOPACKAGEINSUREDFEE',
    payload: data,
  }),
  getDataFormCargoAdditionalById: (data: ADDITIONALID) => ({
    type: 'GETDATAFORMCARGOADDITIONALBYID',
    payload: data,
  }),
  saveDataFormCargoAdditional: (data: any) => ({
    type: 'SAVEDATAFORMCARGOADDITIONAL',
    payload: data,
  }),
  updateSumInsuredFee: (data: CARGOPACKAGEINSUREDFEE) => ({
    type: 'UPDATESUMINSUREDFEE',
    payload: data,
  }),
  getDataFormMarineOfferFeeByCode: (data: MARINEPACKAGECODE) => ({
    type: 'GETDATAFORMMARINEOFFERFEEBYCODE',
    payload: data,
  }),
  saveDataFormMarineOfferFee: (data: any) => ({type: 'SAVEDATAFORMMARINEOFFERFEE', payload: data}),
  updateCurrencyState: (data: IUPDATECURRENCYSTATE) => ({
    type: 'UPDATECURRENCYSTATE',
    payload: data,
  }),
  getContractExtraData: (data: PAYMENTTIMEDAYID) => ({
    type: 'GETCONTRACTEXTRADATA',
    payload: data,
  }),
  saveContractExtraData: (data: PAYMENTTIMEDAY) => ({
    type: 'SAVECONTRACTEXTRADATA',
    payload: data,
  }),
  getListMarineInsured: (data: INSUREDFILTER) => ({
    type: 'GETLISTMARINEINSURED',
    payload: data,
  }),
  saveListMarineInsured: (data: any) => ({
    type: 'SAVELISTMARINEINSURED',
    payload: data,
  }),
  getMarineInsuredById: (data: any) => ({
    type: 'GETMARINEINSUREDBYID',
    payload: data,
  }),
  saveMarineInsuredInfo: (data: any) => ({
    type: 'SAVEMARINEINSUREDINFO',
    payload: data,
  }),
  getListLocalInsured: (data: LOCAINSUREDFILTER) => ({
    type: 'GETLISTLOCALINSURED',
    payload: data,
  }),
  saveListLocalInsured: (data: LOCATIONLIST) => ({
    type: 'SAVELISTLOCALINSURED',
    payload: data,
  }),
  getLocationInsuredById: (data: PROPERTYBYID) => ({
    type: 'GETLOCATIONINSUREDBYID',
    payload: data,
  }),
  saveLocationInsuredInfo: (data: LOCATIONLIST) => ({
    type: 'SAVELOCATIONINSUREDINFO',
    payload: data,
  }),
  updatePropertyInsuredId: (data: PROPERTYUPDATEID) => ({
    type: 'UPDATEPROPERTYINSUREDID',
    payload: data,
  }),
  saveListRiskBenefitDetail: (data: RISKBENFITDETAILS) => ({
    type: 'SAVELISTRISKBENFITDETAIL',
    payload: data,
  }),
  getListTechnicalInsured: (data: LOCAINSUREDFILTER) => ({
    type: 'GETLISTTECHNICALINSURED',
    payload: data,
  }),
  saveListTechnicalInsured: (data: LOCATIONLIST) => ({
    type: 'SAVELISTTECHNICALINSURED',
    payload: data,
  }),
  getListMicroInsured: (data: INSUREDFILTER) => ({
    type: 'GETLISTMICROINSURED',
    payload: data,
  }),
  saveListMicroInsured: (data: any) => ({
    type: 'SAVELISTMICROINSURED',
    payload: data,
  }),
  getDataFormMicroOfferFeeByCode: (data: MARINEPACKAGECODE) => ({
    type: 'GETDATAFORMMICROOFFERFEEBYCODE',
    payload: data,
  }),
  saveDataFormMicroOfferFee: (data: any) => ({
    type: 'SAVEDATAFORMMICROOFFERFEE',
    payload: data,
  }),
  addExtensionInfos: (data: PRODUCTINFORS) => ({type: 'ADDEXTENSIONINFOS', payload: data}),
  getMicroInsuredById: (data: any) => ({
    type: 'GETMICROINSUREDBYID',
    payload: data,
  }),
  saveMicroInsuredInfo: (data: any) => ({
    type: 'SAVEMICROINSUREDINFO',
    payload: data,
  }),
  getPropertyListContract: (data: any) => ({
    type: 'GETPROPERTYLISTCONTRACT',
    payload: data,
  }),
  savePropertyListContract: (data: any) => ({
    type: 'SAVEPROPERTYLISTCONTRACT',
    payload: data,
  }),
  updatePropertyAddress: (data: PROPERTYADDRESS) => ({
    type: 'UPDATEPROPERTYADDRESS',
    payload: data,
  }),
}

const updateReduxState = (state: ProductInitialStateModel, formName: string) => {
  switch (formName) {
    case 'formTechnicalOfferFee':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formTechnicalOfferFeeState,
      }
      break
    case 'formTechnicalList':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formTechnicalListState,
      }
      break
    case 'formPropertyOfferFee':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formPropertyOfferFeeState,
      }
      break
    case 'formPropertyLocation':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formPropertyLocaInsuredState,
      }
      break
    case 'formProductHouseInsured':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formProductHouseInsuredState,
      }
      break
    case 'formCargoOfferFee':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formCargoOfferFeeState,
      }
      break
    case 'formCargoListInsured':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formCargoListInsuredState,
      }
      break
    case 'formMarineOfferFee':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formMarineOfferFeeState,
      }
      break
    case 'formMarineListInsured':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formMarineInsuredState,
      }
      break
    case 'formMicroOfferFee':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formMicroOfferFeeState,
      }
      break
    case 'formMicroListInsured':
      state.form.formData[formName] = {
        ...state.form.formData[formName],
        ...formMicroInsuredState,
      }
      break
    default:
      break
  }
}

export const productInsuReducer = (state = productInitialState, action: ActionTypes) => {
  switch (action.type) {
    case 'UPDATEREDUXINITIALSTATE':
      let updatReduxState = JSON.parse(JSON.stringify(state))
      let arrForm = action.payload.addForm.split(',')
      if (arrForm.length > 0 && updatReduxState.length > 0) {
        arrForm.forEach((o: string) => {
          updateReduxState(updatReduxState[0], o)
        })
      }
      return updatReduxState
    case 'ADDNEWPRODUCT':
      const newTabState = JSON.parse(JSON.stringify(state))
      if (newTabState.length === 1 && newTabState[0].tabName == undefined) {
        newTabState[0].tabName = action.payload.tab
        newTabState[0].sellingContractId = action.payload.tab
        newTabState[0].customerCode = action.payload.customerCode
        newTabState[0].customerVersion = action.payload.customerVersion
        newTabState[0].groupDomainCode = action.payload.groupDomainCode
        newTabState[0].form.formData.formProductInsurancePlan.productCode =
          action.payload.productCode
        newTabState[0].form.activeForm = 1
        newTabState[0].contractType = action.payload.contractType
        newTabState[0].contractKind = action.payload.contractKind
        newTabState[0].originalContract = action.payload.originalContract
      } else {
        const obj = {
          tabName: action.payload.tab,
          sellingContractId: action.payload.tab,
          customerCode: action.payload.customerCode,
          customerVersion: action.payload.customerVersion,
          contractType: action.payload.contractType,
          contractKind: action.payload.contractKind,
          originalContract: action.payload.originalContract,
          groupDomainCode: action.payload.groupDomainCode,
          packageExtension: undefined,
          packageInsurance: undefined,
          form: {
            activeForm: 1,
            formStatus: null,
            cleanFormStatus: false,
            formData: {
              formProductInsurancePlan: formProductInsurancePlanState,
              formProductContract: formProductContractState,
            },
          },
        }
        if (action.payload.formState) {
          let arrForm = action.payload.formState.split(',')
          if (arrForm.length > 0) {
            arrForm.forEach((o: string) => {
              updateReduxState(obj, o)
            })
          }
        }
        newTabState.push(obj)
      }
      return newTabState
    case 'REMOVETABPRODUCT':
      const removeTabState = JSON.parse(JSON.stringify(state))
      const tabRemoved = removeTabState.filter((o: any) => o.tabName !== action.payload)
      return tabRemoved
    case 'MODIFYTABPRODUCT':
      const modifyTabState = JSON.parse(JSON.stringify(state))
      const currentModifyTab = modifyTabState.find(
        (o: any) => o.tabName == action.payload.currentTab
      )
      if (currentModifyTab) {
        currentModifyTab.sellingContractId = action.payload.newTabName
        currentModifyTab.customerCode = action.payload.customerCode
        currentModifyTab.customerVersion = action.payload.customerVersion
        currentModifyTab.groupDomainCode = action.payload.groupDomainCode
        currentModifyTab.contractType = action.payload.contractType
      }
      return modifyTabState
    case 'ADDPRODUCTINFORS':
      const addProductTabState = JSON.parse(JSON.stringify(state))
      const {key, value, tab, form} = action.payload
      let addProductTab = addProductTabState.find((o: any) => o.tabName == tab)
      if (addProductTab) {
        addProductTab.form.formData[form][key] = value
        if (
          form == 'formHouseInsured' ||
          form == 'formMarineOfferFee' ||
          form == 'formMarineListInsured' ||
          form == 'formPropertyOfferFee' ||
          form == 'formMicroOfferFee'
        ) {
          if (key == 'startDate') {
            let dataCalculated = calculateDateNew(value, false)
            addProductTab.form.formData[form].expireDate = dataCalculated
          }
        }
      }
      return addProductTabState
    case 'ACTIVEFORMPRODUCT':
      const activeFormState = JSON.parse(JSON.stringify(state))
      let currentTab = activeFormState.find((o: any) => o.tabName == action.payload.tab)
      if (currentTab) {
        currentTab.form.activeForm = action.payload.form
      }
      return activeFormState
    case 'UPDATEPRODUCTCONTRACTSTATUS':
      const contractStatusState = JSON.parse(JSON.stringify(state))
      let contractStatusTab = contractStatusState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (contractStatusTab) {
        contractStatusTab.form.formStatus = action.payload.status
      }
      return contractStatusState
    case 'UPDATEBUSSINESSFORMPRODUCT':
      const updateBussinessProductState = JSON.parse(JSON.stringify(state))
      let updateBussinessProductTab = updateBussinessProductState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (updateBussinessProductTab) {
        updateBussinessProductTab.form.formData[action.payload.form].business =
          action.payload.bussiness
        updateBussinessProductTab.form.formData[action.payload.form].businessName =
          action.payload.bussinessName
      }
      return updateBussinessProductState
    case 'SAVEPRODUCTPACKAGEINSURANCES':
      const packageInsuranceState = JSON.parse(JSON.stringify(state))
      const packageInsuranceTab = packageInsuranceState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (packageInsuranceTab) {
        packageInsuranceTab.packageInsurance = action.payload.data
      }
      return packageInsuranceState
    case 'UPDATEPRODUCTFEETAX':
      const feeTaxState = JSON.parse(JSON.stringify(state))
      const feeTaxTab = feeTaxState.find((o: any) => o.sellingContractId == action.payload.tab)
      if (feeTaxTab) {
        feeTaxTab.form.formData[action.payload.form].sumFee = action.payload.fee
        feeTaxTab.form.formData[action.payload.form].sumTax = action.payload.tax
      }
      return feeTaxState
    case 'UPDATEPACKAGEBENEFITS':
      const packageBenefitsState = JSON.parse(JSON.stringify(state))
      const packageBenefitsTab = packageBenefitsState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (packageBenefitsTab) {
        if (action.payload.keyBenefit)
          packageBenefitsTab.form.formData[action.payload.form][action.payload.keyBenefit] =
            action.payload.benifits
        if (action.payload.keyExtension)
          packageBenefitsTab.form.formData[action.payload.form][action.payload.keyExtension] =
            action.payload.extensions
      }
      return packageBenefitsState
    case 'CLEARFORM':
      const clearFormState = JSON.parse(JSON.stringify(state))
      const clearFormTab = clearFormState.find((o: any) => o.tabName == action.payload.tab)
      if (clearFormTab) {
        clearFormTab.form.cleanFormStatus = true
        for (const o in clearFormTab.form.formData[action.payload.form]) {
          if (action.payload.form == 'formProductHouseInsured') {
            if (
              o !== 'startDate' &&
              o !== 'expireDate' &&
              o !== 'listHouse' &&
              o !== 'certType' &&
              o !== 'objectInsuredType' &&
              o !== 'fieldInput'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = null
            } else if (o == 'startDate') {
              let date = moment().format('YYYY/MM/DD HH:mm')
              clearFormTab.form.formData[action.payload.form][o] = date
              let dataCalculated = calculateDateNew(moment().format('YYYY/MM/DD HH:mm'), true)
              clearFormTab.form.formData[action.payload.form].expireDate = dataCalculated
            } else if (o == 'objectInsuredType') {
              clearFormTab.form.formData[action.payload.form][o] = '1'
            }
          }
          if (action.payload.form === 'formCargoOfferFee') {
            if (
              o !== 'tripNumber' &&
              o !== '_sellingContractCargoPackageBenefits' &&
              o !== '_sellingContractCargoPackageExtensions' &&
              o !== '_sellingContractCargoPackageExtraFee' &&
              o !== '_sellingContractCargoPackageDeductibles'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = null
            } else if (
              o === '_sellingContractCargoPackageBenefits' ||
              o === '_sellingContractCargoPackageExtensions' ||
              o === '_sellingContractCargoPackageExtraFee' ||
              o === '_sellingContractCargoPackageDeductibles'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = []
            } else if (o === 'tripNumber') {
              clearFormTab.form.formData[action.payload.form][o] = '0'
            }
          }
          if (action.payload.form === 'formMarineOfferFee') {
            if (
              o !== '_sellingContractMarinePackageBenefitDtos' &&
              o !== '_sellingContractMarinePackageExtensionDtos' &&
              o !== '_sellingContractMarinePackageDeductibleDtos' &&
              o !== 'startDate' &&
              o !== 'expireDate' &&
              o !== 'amountShip' &&
              o !== 'seat' &&
              o !== 'numberOfCrew'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = null
            } else if (
              o === '_sellingContractMarinePackageBenefitDtos' ||
              o === '_sellingContractMarinePackageExtensionDtos' ||
              o === '_sellingContractMarinePackageDeductibleDtos'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = []
            } else if (o === 'startDate') {
              clearFormTab.form.formData[action.payload.form][o] = moment().format('YYYY/MM/DD')
            } else if (o === 'expireDate') {
              clearFormTab.form.formData[action.payload.form].expireDate = calculateDateNew(
                moment().format('YYYY/MM/DD'),
                false
              )
            } else if (o === 'amountShip' || o === 'seat' || o === 'numberOfCrew') {
              clearFormTab.form.formData[action.payload.form][o] = '1'
            }
          }
          if (action.payload.form === 'formMarineListInsured') {
            if (
              o !== 'listMarine' &&
              o !== 'packageChoosed' &&
              o !== 'totalRows' &&
              o !== '_sellingContractMarineBenefitDtos' &&
              o !== '_sellingContractMarineExtensionDtos' &&
              o !== '_sellingContractMarineDeductibleDtos'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = null
            } else if (
              o === '_sellingContractMarineBenefitDtos' ||
              o === '_sellingContractMarineExtensionDtos' ||
              o === '_sellingContractMarineDeductibleDtos'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = []
            }
          }
          if (action.payload.form === 'formPropertyLocation') {
            if (
              o !== 'packageCode' &&
              o !== 'listLocaltion' &&
              o !== 'totalRows' &&
              o !== 'fieldInputs' &&
              o !== 'startActivity' &&
              o !== 'expireActivity' &&
              o !== '_sellingContractPropertyBenefitDtos' &&
              o !== '_sellingContractPropertyExtensionDto' &&
              o !== '_sellingContractPropertyDeductibleDto' &&
              o !== '_sellingContractPropertyRiskDto' &&
              o !== '_sellingContractPropertyBusinessInterruptionDto'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = null
            } else if (
              o === '_sellingContractPropertyRiskDto' ||
              o === '_sellingContractPropertyBusinessInterruptionDto' ||
              o === '_sellingContractPropertyBenefitDtos' ||
              o === '_sellingContractPropertyExtensionDto' ||
              o === '_sellingContractPropertyDeductibleDto'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = []
            } else if (o === 'startActivity' || o === 'expireActivity') {
              clearFormTab.form.formData[action.payload.form][o] = moment().format('YYYY/MM/DD')
            }
          }
          if (action.payload.form === 'formMicroOfferFee') {
            if (
              o !== 'startDate' &&
              o !== 'expireDate' &&
              o !== 'sellingContractMicroBenefitPackage' &&
              o !== 'sellingContractMicroExtensionPackage' &&
              o !== 'sellingContractMicroDeductiblePackage'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = null
            } else if (
              o === 'sellingContractMicroBenefitPackage' ||
              o === 'sellingContractMicroExtensionPackage' ||
              o === 'sellingContractMicroDeductiblePackage'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = []
            } else if (o === 'startDate') {
              clearFormTab.form.formData[action.payload.form][o] = moment().format('YYYY/MM/DD')
            } else if (o === 'expireDate') {
              clearFormTab.form.formData[action.payload.form].expireDate = calculateDateNew(
                moment().format('YYYY/MM/DD'),
                false
              )
            }
          }
          if (action.payload.form === 'formMicroListInsured') {
            if (
              o !== 'listMicro' &&
              o !== 'packageChoosed' &&
              o !== 'totalRows' &&
              o !== '_sellingContractMicroBenefitPackage' &&
              o !== '_sellingContractMicroExtensionPackage' &&
              o !== '_sellingContractMicroDeductiblePackage'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = null
            } else if (
              o === '_sellingContractMicroBenefitPackage' ||
              o === '_sellingContractMicroExtensionPackage' ||
              o === '_sellingContractMicroDeductiblePackage'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = []
            }
          }
          if (action.payload.form === 'formPropertyOfferFee') {
            if (
              o !== 'listLocaltion' &&
              o !== 'totalRows' &&
              o !== '_sellingContractPropertyBenefitDtos' &&
              o !== '_sellingContractPropertyExtensionDto' &&
              o !== '_sellingContractPropertyDeductibleDto' &&
              o !== '_sellingContractPropertyRiskBenefitDtos'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = null
            } else if (
              o === '_sellingContractPropertyBenefitDtos' ||
              o === '_sellingContractPropertyExtensionDto' ||
              o === '_sellingContractPropertyDeductibleDto' ||
              o === '_sellingContractPropertyRiskBenefitDtos'
            ) {
              clearFormTab.form.formData[action.payload.form][o] = []
            }
          }
        }
      }
      return clearFormState
    case 'RESETCLEARFORM':
      const resetClearState = JSON.parse(JSON.stringify(state))
      const resetClearTab = resetClearState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (resetClearTab) {
        resetClearTab.form.cleanFormStatus = false
      }
      return resetClearState
    case 'CLONEFORM':
      const cloneState = JSON.parse(JSON.stringify(state))
      const cloneTab = cloneState.find((o: any) => o.sellingContractId == action.payload.tab)
      if (cloneTab) {
        cloneTab.form.formData[action.payload.form].id = null
        if (action.payload.form === 'formProductHouseInsured') {
          cloneTab.form.formData[action.payload.form].name = null
        }
        if (action.payload.form === 'formMarineListInsured') {
          cloneTab.form.formData[action.payload.form].shipName = null
        }
        if (action.payload.form === 'formPropertyLocation') {
          let dataForm = cloneTab.form.formData[action.payload.form]
          dataForm.address = null
          dataForm.longitude = null
          dataForm.latitude = null
          dataForm.addressName = null
          dataForm.sumFee = null
          dataForm.sumTax = null
          dataForm.sumFeeOffer = null
          dataForm.sumTaxOffer = null
          dataForm.riskLevel = null
          dataForm._sellingContractPropertyBenefitDtos = []
          dataForm._sellingContractPropertyExtensionDto = []
          dataForm._sellingContractPropertyDeductibleDto = []
          //reset id risk and business interruption
          dataForm._sellingContractPropertyRiskDto.forEach((ele: any, index: number) => {
            ele.id = index
          })
          dataForm._sellingContractPropertyBusinessInterruptionDto.forEach(
            (ele: any, index: number) => {
              ele.id = index
            }
          )
        }
        if (action.payload.form === 'formMicroListInsured') {
          cloneTab.form.formData[action.payload.form].name = null
        }
      }
      return cloneState
    case 'GETHOUSEINSUREDBYID':
      return state
    case 'SAVEHOUSEINSURED':
      const houseInfoState = JSON.parse(JSON.stringify(state))
      const houseInfoStateTab = houseInfoState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (houseInfoStateTab) {
        houseInfoStateTab.form.formData.formProductHouseInsured.id = action.payload.id
        houseInfoStateTab.form.formData.formProductHouseInsured.name =
          action.payload.data._sellingContractHouseDtos[0].name
        houseInfoStateTab.form.formData.formProductHouseInsured.address =
          action.payload.data._sellingContractHouseDtos[0].address
        houseInfoStateTab.form.formData.formProductHouseInsured.ownerType =
          action.payload.data._sellingContractHouseDtos[0].ownerType.toString()
        houseInfoStateTab.form.formData.formProductHouseInsured.houseType =
          action.payload.data._sellingContractHouseDtos[0].houseType.toString()
        houseInfoStateTab.form.formData.formProductHouseInsured.businessHouseType =
          action.payload.data._sellingContractHouseDtos[0].businessHouseType.toString()
        houseInfoStateTab.form.formData.formProductHouseInsured.fireFighting =
          action.payload.data._sellingContractHouseDtos[0].fireFighting.toString()
        houseInfoStateTab.form.formData.formProductHouseInsured.yearBuilt =
          action.payload.data._sellingContractHouseDtos[0].yearBuilt.toString()
        houseInfoStateTab.form.formData.formProductHouseInsured.floorNumber =
          action.payload.data._sellingContractHouseDtos[0].floorNumber.toString()
        houseInfoStateTab.form.formData.formProductHouseInsured.price = formatter(
          action.payload.data._sellingContractHouseDtos[0].price
        )
        houseInfoStateTab.form.formData.formProductHouseInsured.packageCode =
          action.payload.data.packageCode
        houseInfoStateTab.form.formData.formProductHouseInsured.sumFee = action.payload.data.sumFee
        houseInfoStateTab.form.formData.formProductHouseInsured.sumTax = action.payload.data.sumTax
        houseInfoStateTab.form.formData.formProductHouseInsured.startDate = moment(
          action.payload.data.startDate,
          'DD/MM/YYYY HH:mm'
        ).format('YYYY/MM/DD')
        houseInfoStateTab.form.formData.formProductHouseInsured.expireDate = moment(
          action.payload.data.expireDate,
          'DD/MM/YYYY HH:mm'
        ).format('YYYY/MM/DD')
        houseInfoStateTab.form.formData.formProductHouseInsured.payeeName =
          action.payload.data.payeeName
        houseInfoStateTab.form.formData.formProductHouseInsured.payeePhone =
          action.payload.data.payeePhone
        houseInfoStateTab.form.formData.formProductHouseInsured.payeeEmail =
          action.payload.data.payeeEmail
        houseInfoStateTab.form.formData.formProductHouseInsured.payeeNameIdentificationNumber =
          action.payload.data.payeeNameIdentificationNumber
        houseInfoStateTab.form.formData.formProductHouseInsured.payeesRelationsShip =
          action.payload.data.payeesRelationsShip
        action.payload.data._sellingContractHouseBenefitDtos.map((o: any) => {
          o.checkboxF = true
        })
        houseInfoStateTab.form.formData.formProductHouseInsured.housePackageBenefitDtos =
          action.payload.data._sellingContractHouseBenefitDtos
      }
      return houseInfoState
    case 'GETLISTHOUSEINSURED':
      return state
    case 'SAVELISTHOUSEINSURED':
      const listHouseState = JSON.parse(JSON.stringify(state))
      const listHouseStateTab = listHouseState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (listHouseStateTab) {
        if (action.payload.data && action.payload.data.items) {
          action.payload.data.items.map((o: any) => {
            o.packageName = listHouseStateTab.packageInsurance.package.packagesHouse.find(
              (x: any) => x.code == o.packageCode
            )?.name
            o.fee = formatter(o.sumFee + o.sumTax)
          })
          listHouseStateTab.form.formData.formProductHouseInsured.listHouse =
            action.payload.data.items
        }
      }
      return listHouseState
    case 'VALIDATEFORMPRODUCT':
      const validateState = JSON.parse(JSON.stringify(state))
      const validateTab = validateState.find((o: any) => o.tabName == action.payload.tab)
      if (validateTab) {
        validateTab.form.formData[action.payload.form].validateForm = action.payload.isError
      }
      return validateState
    case 'GETHOUSECONTRACTSTEP4BYID':
      return state
    case 'SAVEHOUSECONTRACTSTEP4BYID':
      const saveContractState = JSON.parse(JSON.stringify(state))
      const saveContractTab = saveContractState.find(
        (o: any) => o.sellingContractId == action.payload.id
      )
      if (saveContractTab) {
        saveContractTab.form.formData.formProductContract.contractNumber =
          action.payload.contractNumber
        saveContractTab.form.formData.formProductContract.created = moment(
          action.payload.createdDate,
          'DD/MM/YYYY'
        ).format('YYYY/MM/DD')
        saveContractTab.form.formData.formProductContract.contractType = action.payload.contractType
        saveContractTab.form.formData.formProductContract.startDate =
          action.payload.startDate != '01/01/0001'
            ? moment(action.payload.startDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
            : null
        saveContractTab.form.formData.formProductContract.purchaseDate =
          action.payload.purchaseDate != '01/01/0001'
            ? moment(action.payload.purchaseDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
            : null
        saveContractTab.form.formData.formProductContract.manager = action.payload.manager
        saveContractTab.form.formData.formProductContract.expireDate =
          action.payload.startDate != '01/01/0001'
            ? moment(action.payload.expireDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
            : null
        saveContractTab.form.formData.formProductContract.totalPerson = action.payload.amountPeople
        saveContractTab.form.formData.formProductContract.adjacentContractNumber =
          action.payload.adjacentContractNumber
        saveContractTab.form.formData.formProductContract.adjacentContractNumberLoss =
          action.payload.adjacentContractNumberLoss
        saveContractTab.form.formData.formProductContract.partyARepresentative =
          action.payload.partyARepresentative
        saveContractTab.form.formData.formProductContract.partyBRepresentative =
          action.payload.partyBRepresentative
        saveContractTab.form.formData.formProductContract.partyAPowerOfAttorney =
          action.payload.partyAPowerOfAttorney
        saveContractTab.form.formData.formProductContract.partyBPowerOfAttorney =
          action.payload.partyBPowerOfAttorney
        saveContractTab.form.formData.formProductContract.partyAPosition =
          action.payload.partyAPosition
        saveContractTab.form.formData.formProductContract.partyBFax = action.payload.partyBFax
        saveContractTab.form.formData.formProductContract.partyBPhone = action.payload.partyBPhone
        saveContractTab.form.formData.formProductContract.partyAPhone = action.payload.partyAPhone
        saveContractTab.form.formData.formProductContract.partyBPosition =
          action.payload.partyBPosition
        saveContractTab.form.formData.formProductContract.bankCode = action.payload.bankCode
        saveContractTab.form.formData.formProductContract.bankNumber = action.payload.bankNumber
        saveContractTab.form.formData.formProductContract._sellingContractPaymentScheduleDtos =
          FormateContractPayment(action.payload._sellingContractPaymentScheduleDtos)
        saveContractTab.form.formData.formProductContract._sellingContractExtraDataDtos =
          action.payload._sellingContractExtraDataDtos
        saveContractTab.form.formData.formProductContract.sumFee = formatter(action.payload.sumFee)
        saveContractTab.form.formData.formProductContract.sumTax = formatter(action.payload.sumTax)
        saveContractTab.form.formData.formProductContract.taxType = action.payload.taxType
        saveContractTab.form.formData.formProductContract._listContractCargoPackages =
          action.payload._listContractCargoPackages
      }
      return saveContractState
    case 'SAVEPRODUCTINSURANCEPLAN':
      const saveProductInsurancePlanState = JSON.parse(JSON.stringify(state))
      const saveProductInsurancePlanTab = saveProductInsurancePlanState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (saveProductInsurancePlanTab) {
        let dataState: InsurancePlanModel =
          saveProductInsurancePlanTab.form.formData.formProductInsurancePlan
        dataState.businessProgramCode = action.payload.data.businessProgramCode
        dataState.productCode = action.payload.data.productCode
        dataState.groupProduct = action.payload.data.groupProduct
        dataState.exploitingType = action.payload.data.exploitingType
        dataState.exploitingCode = action.payload.data.exploitingCode
        dataState.introductionCode = action.payload.data.introductionCode
        dataState.curencyMoney = action.payload.data.curencyMoney
        dataState.curencyFee = action.payload.data.curencyFee
        dataState.exchangeRate = action.payload.data.exchangeRate
        dataState.exchangeRateNote = action.payload.data.exchangeRateNote
        dataState.tpaType = action.payload.data.tpaType
        dataState.tpaFee = action.payload.data.tpaFee
        dataState.tpa = action.payload.data.tpa
        dataState.nationality = action.payload.data.nationality
        dataState.business = action.payload.data.business
        dataState.businessName = action.payload.data.businessName
        dataState.paymentTimeType = action.payload.data.paymentTimeType
        dataState.adjacentContractNumberLoss = action.payload.data.adjacentContractNumberLoss
        dataState.adjacentContractNumber = action.payload.data.adjacentContractNumber
        dataState.calculationType = action.payload.data.calculationType
      }
      return saveProductInsurancePlanState

    case 'DELETEBENEFITINFO':
      const deleteBenefitState = JSON.parse(JSON.stringify(state))
      const deleteBenefitTab = deleteBenefitState.find((o: any) => o.tabName == action.payload.tab)
      if (deleteBenefitTab) {
        deleteBenefitTab.form.formData[action.payload.form][action.payload.key] =
          deleteBenefitTab.form.formData[action.payload.form][action.payload.key].filter(
            (o: any) => o.benefitCode !== action.payload.value
          )
      }
      return deleteBenefitState
    case 'ADDBENEFITINFO':
      let addBenefitTabState = JSON.parse(JSON.stringify(state))
      let addBenefitTab = addBenefitTabState.find((o: any) => o.tabName == action.payload.tab)
      if (addBenefitTab) {
        if (action.payload.type == 'Rủi ro chính') {
          let checkMainExisted = addBenefitTab.form.formData[action.payload.form][
            action.payload.key
          ].find((o: any) => o.type == 'Rủi ro chính')
          if (checkMainExisted) {
            addBenefitTab.form.formData[action.payload.form][action.payload.key].splice(
              0,
              1,
              action.payload.value[0]
            )
          } else {
            addBenefitTab.form.formData[action.payload.form][action.payload.key].unshift(
              action.payload.value[0]
            )
          }
        }
        // if (addBenefitTab.form.formData[action.payload.form][action.payload.key]) {
        //   addBenefitTab.form.formData[action.payload.form][action.payload.key] =
        //     addBenefitTab.form.formData[action.payload.form][action.payload.key].concat(
        //       action.payload.value
        //     )
        // } else {
        //   addBenefitTab.form.formData[action.payload.form][action.payload.key] =
        //     action.payload.value
        // }
      }
      return addBenefitTabState
    case 'UPDATEBENEFITINFO':
      let updateBenefitTabState = JSON.parse(JSON.stringify(state))
      let updateBenefitTab = updateBenefitTabState.find((o: any) => o.tabName == action.payload.tab)
      if (updateBenefitTab) {
        updateBenefitTab.form.formData[action.payload.form][action.payload.key] =
          action.payload.value
      }
      return updateBenefitTabState
    case 'SAVEPACKAGEEXTENSIONS':
      const extensionState = JSON.parse(JSON.stringify(state))
      const extensionTab = extensionState.find(
        (o: any) => o.sellingContractId == action.payload.tab
      )
      if (extensionTab) {
        extensionTab.packageExtension = action.payload.data
      }
      return extensionState
    case 'GETDATAFORMCARGOOFFERFEEBYCODE':
      return state
    case 'SAVEDATAFORMCARGOOFFERFEE':
      const offerFeeState = JSON.parse(JSON.stringify(state))
      const offerFeeTab = offerFeeState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (offerFeeTab) {
        let dataState: any = offerFeeTab.form.formData.formCargoOfferFee
        dataState.oldPackageCode = action.payload?.oldPackageCode
          ? action.payload?.oldPackageCode
          : null
        dataState.id = action.payload.id
        dataState.packageCode = action.payload.packageCode
        dataState.code = action.payload.code
        dataState.ecargoType = action.payload.ecargoType
        dataState.contractPackageType = action.payload.contractPackageType
        dataState.packageName = action.payload.packageName
        dataState.startDate =
          action.payload.startDate != '01/01/0001'
            ? moment(action.payload.startDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
            : null
        dataState.expireDate =
          action.payload.expireDate != '01/01/0001'
            ? moment(action.payload.expireDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
            : null
        dataState.additionalContract = action.payload.additionalContract
        dataState.billOfLading = action.payload.billOfLading
        dataState.inspectionCompany = action.payload.inspectionCompany
        dataState.transShipment = action.payload.transShipment.toString()
        dataState.shippingType = action.payload.shippingType
        dataState.commodityGroup = action.payload.commodityGroup
        dataState.commodityType = action.payload.commodityType
        dataState.commodityName = action.payload.commodityName
        dataState.packingType = action.payload.packingType
        dataState.distance = action.payload.distance.toString()
        dataState.manufacturingYear = action.payload.manufacturingYear
        dataState.unit = action.payload.unit
        dataState.weightOrQuantity = action.payload.weightOrQuantity.toString()
        dataState.price = action.payload.price.toString()
        dataState.tripNumber = action.payload.tripNumber
        dataState.imoShip = action.payload.imoShip
        dataState.note = action.payload.note
        dataState.lossRatio = action.payload.lossRatio
        dataState.sumFee = dataState.contractPackageType === 3 ? action.payload.sumFee : 0
        dataState.sumTax = dataState.contractPackageType === 3 ? action.payload.sumTax : 0
        dataState.from = action.payload.from
        dataState.portFrom = action.payload.portFrom
        dataState.to = action.payload.to
        dataState.portTo = action.payload.portTo
        dataState.nameTransportation = action.payload.nameTransportation
        dataState.valuationBasis = action.payload.valuationBasis
        dataState.letterCredit = action.payload.letterCredit
        dataState.invoiceNo = action.payload.invoiceNo
        dataState.sumFeeCargo = dataState.weightOrQuantity * dataState.price
        dataState.sumInsuredFee = formatter(
          action.payload._sellingContractCargoPackageBenefitDtos[0].standardSumInsured
        )
        dataState._sellingContractCargoPackageBenefits =
          action.payload._sellingContractCargoPackageBenefitDtos
        dataState._sellingContractCargoPackageExtensions =
          action.payload._sellingContractCargoPackageExtensionDtos
        dataState._sellingContractCargoPackageDeductibles =
          action.payload._sellingContractCargoPackageDeductibleDtos.map((o: any) => ({
            id: o.id,
            deductibleRate: o.offerLossRatio,
            minimumDeductible: o.offerMinimum,
            note: o.offerNote,
          }))
        dataState._sellingContractCargoPackageBenefits.map((o: any) => {
          // o.checkboxF = true
          if (o.startDate != '01/01/0001') o.startDate = moment(o.startDate, 'DD/MM/YYYY').toDate()
          if (o.expireDate != '01/01/0001') {
            o.expireDate = moment(o.expireDate, 'DD/MM/YYYY').toDate()
          }
          if (!o.type) o.type = 'Rủi ro chính'
          if (dataState.contractPackageType !== 3) {
            o.approveSumInsured = 0
            o.approveRate = 0
            o.approveInsuranceFee = 0
            o.approveDiscountRate = 0
            o.approveInsuranceFeeOriginal = 0
            o.approveTax = 0
          }
        })
        action.payload._sellingContractCargoPackageRiskAndAdditionalFeeDtos.map(
          (o: any, i: number) => {
            dataState._sellingContractCargoPackageBenefits.push({
              id: o.sellingContractCargoPackageId,
              benefitCode: o.riskCode,
              benefitName: o.riskName,
              type: 'Rủi ro phụ',
              ordinalNumbers: i + 1,
              startDate: o.startDate,
              expireDate: o.expireDate,
              note: o.note,
              standardInsuranceFee: o.standardInsuranceFee,
              standardSumInsured: o.standardSumInsured,
              standardRate: o.standardRate,
              offerSumInsured: o.offerSumInsured,
              offerRate: o.offerRate,
              offerInsuranceFee: o.offerInsuranceFee,
              offerDiscountRate: o.offerDiscountRate,
              offerInsuranceFeeOriginal: o.offerInsuranceFee,
              offerTax: o.offerTax ? o.offerTax : 0,
              approveSumInsured: dataState.contractPackageType === 3 ? o.approveSumInsured : 0,
              approveRate: dataState.contractPackageType === 3 ? o.approveRate : 0,
              approveInsuranceFee: dataState.contractPackageType === 3 ? o.approveInsuranceFee : 0,
              approveDiscountRate: dataState.contractPackageType === 3 ? o.approveDiscountRate : 0,
              approveInsuranceFeeOriginal:
                dataState.contractPackageType === 3 ? o.approveInsuranceFee : 0,
              approveTax: dataState.contractPackageType === 3 ? o.approveTax : 0,
              taxRate: o.taxRate ? o.taxRate : 0,
            })
          }
        )
        dataState._sellingContractCargoPackageExtensions.map((o: any) => {
          if (o.startDate != '01/01/0001') o.startDate = moment(o.startDate, 'DD/MM/YYYY').toDate()
          if (o.expireDate != '01/01/0001')
            o.expireDate = moment(o.expireDate, 'DD/MM/YYYY').toDate()
        })
        action.payload._sellingContractCargoPackageRiskAndAdditionalFeeDtos.map((o: any) => {
          dataState._sellingContractCargoPackageExtraFee.push({
            id: o.sellingContractCargoPackageId,
            name: o.riskName,
            cargoFeeId: 0,
            company: '',
            groupDomainCode: '',
            cargoFeeIncreaseOrDecreaseFeeType: parseInt(o.riskCode),
            from: 0,
            to: 0,
            rate: o.standardRate,
            fee: 0,
            tax: 0,
            amountMinimum: 0,
            offerDiscountRate: o.offerDiscountRate,
          })
        })
      }
      return offerFeeState
    case 'DELETEEXTENSIONINFO':
      const deleteExtensionState = JSON.parse(JSON.stringify(state))
      const deleteExtensionTab = deleteExtensionState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (deleteExtensionTab) {
        deleteExtensionTab.form.formData[action.payload.form][action.payload.key] =
          deleteExtensionTab.form.formData[action.payload.form][action.payload.key].filter(
            (o: any) => o.extensionCode !== action.payload.value
          )
      }
      return deleteExtensionState
    case 'SAVEPACKAGEBENEFITS':
      const benefitState = JSON.parse(JSON.stringify(state))
      const benefitTab = benefitState.find((o: any) => o.sellingContractId == action.payload.tab)
      if (benefitTab) {
        benefitTab.form.formData[action.payload.form][action.payload.key].map((o: any) => {
          if (o.benefitCode === action.payload.code) {
            o.benefitName = action.payload.value.benefitName
            o.type = action.payload.value.type
            o.ordinalNumbers = action.payload.value.ordinalNumbers
            o.startDate = action.payload.value.startDate
            o.expireDate = action.payload.value.expireDate
            o.note = action.payload.value.note
            o.standardInsuranceFee = action.payload.value.standardInsuranceFee
            o.standardSumInsured = action.payload.value.standardSumInsured
            o.standardRate = action.payload.value.standardRate
            o.offerSumInsured = action.payload.value.offerSumInsured
            o.offerRate = action.payload.value.offerRate
            o.offerInsuranceFee = action.payload.value.offerInsuranceFee
            o.offerDiscountRate = action.payload.value.offerDiscountRate
            o.offerInsuranceFeeOriginal = action.payload.value.offerInsuranceFeeOriginal
            o.offerTax = action.payload.value.offerTax
            o.approveSumInsured = action.payload.value.approveSumInsured
            o.approveRate = action.payload.value.approveRate
            o.approveInsuranceFee = action.payload.value.approveInsuranceFee
            o.approveDiscountRate = action.payload.value.approveDiscountRate
            o.approveInsuranceFeeOriginal = action.payload.value.approveInsuranceFeeOriginal
            o.approveTax = action.payload.value.approveTax
            o.benefitCode = action.payload.value.benefitCode
          }
        })
      }
      return benefitState
    case 'SAVEPACKAGETEMPLATE':
      const packageTemplateState = JSON.parse(JSON.stringify(state))
      const packageTemplateTab = packageTemplateState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (packageTemplateTab) {
        packageTemplateTab.packageTemplate = action.payload.data
      }
      return packageTemplateState
    case 'UPDATECARGOPACKAGEINSUREDFEE':
      const updateCargoPackageInsuredFeeState = JSON.parse(JSON.stringify(state))
      const cargoPackageInsuredFeeTab = updateCargoPackageInsuredFeeState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (cargoPackageInsuredFeeTab) {
        const formCargoOfferFee = cargoPackageInsuredFeeTab.form.formData.formCargoOfferFee
        if (formCargoOfferFee.weightOrQuantity && formCargoOfferFee.price) {
          formCargoOfferFee.sumFeeCargo =
            parseFee(formCargoOfferFee.weightOrQuantity) * parseFee(formCargoOfferFee.price)
          if (formCargoOfferFee.sumInsuredFee && formCargoOfferFee.sumInsuredFee !== '0') {
            if (formCargoOfferFee.sumFeeCargo < parseFee(formCargoOfferFee.sumInsuredFee)) {
              formCargoOfferFee.sumInsuredFee = formatter(formCargoOfferFee.sumFeeCargo)
            }
          } else {
            formCargoOfferFee.sumInsuredFee = formatter(formCargoOfferFee.sumFeeCargo)
          }
        } else {
          formCargoOfferFee.sumFeeCargo = 0
          formCargoOfferFee.sumInsuredFee = 0
        }
      }
      return updateCargoPackageInsuredFeeState
    case 'GETDATAFORMCARGOADDITIONALBYID':
      return state
    case 'SAVEDATAFORMCARGOADDITIONAL':
      const additinalState = JSON.parse(JSON.stringify(state))
      const additionalTab = additinalState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (additionalTab) {
        let dataState: any = additionalTab.form.formData.formCargoListInsured
        dataState.sellingContractId = action.payload.sellingContractId
        dataState.packageCode = action.payload.packageCode
        dataState.id = action.payload._sellingContractCargoDtos[0].sellingContractObjectInsuredId
        dataState.additionalContract =
          action.payload._sellingContractCargoDtos[0].additionalContract
        dataState.billOfLading = action.payload._sellingContractCargoDtos[0].billOfLading
        dataState.commodityGroup = action.payload._sellingContractCargoDtos[0].commodityGroup
        dataState.commodityName = action.payload._sellingContractCargoDtos[0].commodityName
        dataState.commodityType = action.payload._sellingContractCargoDtos[0].commodityType
        dataState.distance = action.payload._sellingContractCargoDtos[0].distance
        dataState.from = action.payload._sellingContractCargoDtos[0].from
        dataState.imoShip = action.payload._sellingContractCargoDtos[0].imoShip
        dataState.inspectionCompany = action.payload._sellingContractCargoDtos[0].inspectionCompany
        dataState.manufacturingYear = action.payload._sellingContractCargoDtos[0].manufacturingYear
        dataState.nameTransportation =
          action.payload._sellingContractCargoDtos[0].nameTransportation
        dataState.note = action.payload._sellingContractCargoDtos[0].note
        dataState.packingType = action.payload._sellingContractCargoDtos[0].packingType
        dataState.portFrom = action.payload._sellingContractCargoDtos[0].portFrom
        dataState.portTo = action.payload._sellingContractCargoDtos[0].portTo
        dataState.price = action.payload._sellingContractCargoDtos[0].price.toString()
        dataState.shippingType = action.payload._sellingContractCargoDtos[0].shippingType
        dataState.to = action.payload._sellingContractCargoDtos[0].to
        dataState.transShipment = action.payload._sellingContractCargoDtos[0].transShipment
        dataState.tripNumber = action.payload._sellingContractCargoDtos[0].tripNumber
        dataState.transShipment = action.payload._sellingContractCargoDtos[0].transShipment
        dataState.unit = action.payload._sellingContractCargoDtos[0].unit
        dataState.valuationBasis = action.payload._sellingContractCargoDtos[0].valuationBasis
        dataState.letterCredit = action.payload._sellingContractCargoDtos[0].letterCredit
        dataState.invoiceNo = action.payload._sellingContractCargoDtos[0].invoiceNo
        dataState.sumFee = action.payload.sumFee
        dataState.weightOrQuantity =
          action.payload._sellingContractCargoDtos[0].weightOrQuantity.toString()
        dataState.sumInsuredFee =
          action.payload._sellingContractCargoBenefitDtos[0].sumInsured.toString()
        dataState.sumFeeCargo =
          dataState.weightOrQuantity && dataState.price
            ? (dataState.weightOrQuantity * dataState.price).toString()
            : '0'
        dataState.startDate =
          action.payload.startDate != '01/01/0001 00:00'
            ? moment(action.payload.startDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
            : null
        dataState.expireDate =
          action.payload.expireDate != '01/01/0001 00:00'
            ? moment(action.payload.expireDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
            : null
        dataState._sellingContractCargoPackageBenefits =
          action.payload._sellingContractCargoBenefitDtos
        dataState._sellingContractCargoPackageExtensions =
          action.payload._sellingContractCargoExtensionDtos
        dataState._sellingContractCargoPackageDeductibles =
          action.payload._sellingContractCargoDeductibleDtos
        dataState._sellingContractCargoPackageExtraFee =
          action.payload._sellingContractCargoRiskAndAdditionalFeeDtos

        dataState._sellingContractCargoPackageBenefits.map((o: any) => (o.type = 'Rủi ro chính'))
        dataState._sellingContractCargoPackageDeductibles.map(
          (o: any, index: number) => (o.id = index)
        )
        dataState._sellingContractCargoPackageExtensions.map(
          (o: any, index: number) => (o.id = index)
        )

        action.payload._sellingContractCargoRiskAndAdditionalFeeDtos.map((o: any) => {
          dataState._sellingContractCargoPackageBenefits.push({
            type: 'Rủi ro phụ',
            startDate: o.startDate ? o.startDate : null,
            expireDate: o.expireDate ? o.expireDate : null,
            benefitCode: o.riskCode,
            benefitName: o.riskName,
            ordinalNumbers: o.ordinalNumbers,
            sumInsured: o.sumInsured,
            rate: o.rate,
            insuranceFee: o.insuranceFee,
            originalFee: o.insuranceFee,
            tax: o.tax,
            originalTax: o.tax,
            note: o.note,
          })
        })
      }
      return additinalState
    case 'UPDATESUMINSUREDFEE':
      const updateSumInsuredFeeState = JSON.parse(JSON.stringify(state))
      const updateSumInsuredFeeTab = updateSumInsuredFeeState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (updateSumInsuredFeeTab) {
        const formCargoAdditional = updateSumInsuredFeeTab.form.formData.formCargoListInsured
        if (formCargoAdditional.weightOrQuantity && formCargoAdditional.price) {
          formCargoAdditional.sumFeeCargo =
            parseFee(formCargoAdditional.weightOrQuantity) * parseFee(formCargoAdditional.price)
          if (formCargoAdditional.sumInsuredFee && formCargoAdditional.sumInsuredFee !== '0') {
            if (formCargoAdditional.sumFeeCargo < parseFee(formCargoAdditional.sumInsuredFee)) {
              formCargoAdditional.sumInsuredFee = formatter(formCargoAdditional.sumFeeCargo)
            }
          } else {
            formCargoAdditional.sumInsuredFee = formatter(formCargoAdditional.sumFeeCargo)
          }
        } else {
          formCargoAdditional.sumFeeCargo = 0
          formCargoAdditional.sumInsuredFee = 0
        }
      }
      return updateSumInsuredFeeState
    case 'GETDATAFORMMARINEOFFERFEEBYCODE':
      return state
    case 'SAVEDATAFORMMARINEOFFERFEE':
      const marineOfferFeeState = JSON.parse(JSON.stringify(state))
      const marineOfferFeeTab = marineOfferFeeState.find(
        (o: any) => o.sellingContractId == action.payload.data.sellingContractId
      )
      if (marineOfferFeeTab) {
        let dataState: any = marineOfferFeeTab.form.formData[action.payload.form]
        if (action.payload.form != 'formMarineListInsured') {
          dataState.id = action.payload.data.id

          dataState.packageCode = action.payload.data.packageCode
          dataState.sumFeeOffer = action.payload.data.sumFee.toString()
          dataState.sumTaxOffer = action.payload.data.sumTax.toString()
          dataState.userApprove = action.payload.data.userApprove
          dataState.address = action.payload.data.address

          // get benefit from packageInsurance
          let dataBenefit = marineOfferFeeTab.packageInsurance.find(
            (o: any) => o.code === dataState.packageCode
          )?.marinePackageBenefitsDto
          // clear checkBox benefit
          dataState._sellingContractMarinePackageBenefitDtos = []
          dataBenefit.map((o: any) => {
            dataState._sellingContractMarinePackageBenefitDtos.push({
              id: o.id,
              benefitName: o.benefitName,
              benefitCode: o.benefitCode,
              ordinalNumbers: o.ordinalNumbers,
              startDate: o.startDate,
              expireDate: o.expireDate,
              insuranceClauseType: o.insuranceClauseType,
              isInsuranceClauseType: null,
              shipGroup: o.shipGroup,
              standardSumInsured: 0,
              standardRate: 0,
              standardInsuranceFee: 0,
              offerSumInsured: 0,
              offerRate: 0,
              offerInsuranceFee: 0,
              offerDiscountRate: 0,
              offerInsuranceFeeOriginal: 0,
              offerTax: 0,
              approveSumInsured: 0,
              approveRate: 0,
              approveInsuranceFee: 0,
              approveDiscountRate: 0,
              approveInsuranceFeeOriginal: 0,
              approveTax: 0,
              note: '',
              checkboxF: false,
              isChoosed: false,
              isChecked: false,
              isRequired: o.isRequired,
            })
          })
          // add benefit
          action.payload.data._sellingContractMarinePackageBenefitDtos.map((o: any) => {
            let index = dataState._sellingContractMarinePackageBenefitDtos.findIndex(
              (ele: any) => ele.benefitCode == o.benefitCode
            )
            let checkRequired = dataState._sellingContractMarinePackageBenefitDtos.findIndex(
              (ele: any) => ele.benefitCode == o.benefitCode && ele.isRequired === true
            )
            if (index !== -1 && checkRequired === -1) {
              dataState._sellingContractMarinePackageBenefitDtos[index] = {
                ...o,
                id: dataState._sellingContractMarinePackageBenefitDtos[index].id,
              }
              dataState._sellingContractMarinePackageBenefitDtos[index].isChecked = true
              dataState._sellingContractMarinePackageBenefitDtos[index].isChoosed = true
              dataState._sellingContractMarinePackageBenefitDtos[index].checkboxF = true
            } else if (index !== -1 && checkRequired !== -1) {
              dataState._sellingContractMarinePackageBenefitDtos[index] = {
                ...o,
                id: dataState._sellingContractMarinePackageBenefitDtos[index].id,
              }
              dataState._sellingContractMarinePackageBenefitDtos[index].isChecked = true
              dataState._sellingContractMarinePackageBenefitDtos[index].isChoosed = true
              dataState._sellingContractMarinePackageBenefitDtos[index].checkboxF = true
              dataState._sellingContractMarinePackageBenefitDtos[index].isRequired = true
            }
          })

          dataState._sellingContractMarinePackageBenefitDtos.map((o: any) => {
            if (o.startDate != '01/01/0001') {
              o.startDate = moment(o.startDate, 'DD/MM/YYYY').toDate()
            }
            if (o.expireDate != '01/01/0001') {
              o.expireDate = moment(o.expireDate, 'DD/MM/YYYY').toDate()
            }
            if (o.insuranceClauseType == '0') {
              o.insuranceClauseType = ''
            }
            if (o.insuranceClauseType == '1') {
              o.insuranceClauseType = 'A'
            }
            if (o.insuranceClauseType == '2') {
              o.insuranceClauseType = 'B'
            }
            if (action.payload.data.contractPackageType !== 3) {
              o.approveSumInsured = 0
              o.approveRate = 0
              o.approveInsuranceFee = 0
              o.approveDiscountRate = 0
              o.approveInsuranceFeeOriginal = 0
              o.approveTax = 0
            }
          })

          // add extension
          dataState._sellingContractMarinePackageExtensionDtos =
            action.payload.data._sellingContractMarinePackageExtensionDtos

          // add deductibles
          dataState._sellingContractMarinePackageDeductibleDtos =
            action.payload.data._sellingContractMarinePackageDeductibleDtos.map((o: any) => ({
              id: o.id,
              deductibleRate: o.offerLossRatio,
              minimumDeductible: o.offerMinimum,
              note: o.offerNote,
            }))
        }

        if (action.payload.form === 'formMarineListInsured') {
          dataState.totalFee = (action.payload.data.sumFee + action.payload.data.sumTax).toString()
          dataState._sellingContractMarineBenefitDtos =
            action.payload.data._sellingContractMarinePackageBenefitDtos

          dataState._sellingContractMarineBenefitDtos.map((o: any) => {
            o.rate = o.approveRate
            o.originalFee = o.approveInsuranceFeeOriginal
            o.originalTax = o.approveTax
          })

          dataState._sellingContractMarineExtensionDtos =
            action.payload.data._sellingContractMarinePackageExtensionDtos
          dataState._sellingContractMarineDeductibleDtos =
            action.payload.data._sellingContractMarinePackageDeductibleDtos.map((o: any) => ({
              lossRatio: o.offerLossRatio,
              minimum: o.offerMinimum,
              note: o.offerNote,
            }))
          dataState.updateCaculator = true
        }

        dataState.oldPackageCode = action.payload.data?.oldPackageCode
          ? action.payload?.oldPackageCode
          : null
        dataState.code = action.payload.data.code
        dataState.contractPackageType = action.payload.data.contractPackageType
        dataState.name = action.payload.data.name
        dataState.tradingLimit = action.payload.data.tradingLimit
        dataState.deadweightTonnage = action.payload.data.deadweightTonnage.toString()
        dataState.engineCapacity = action.payload.data.engineCapacity.toString()
        dataState.manufacturingYear = action.payload.data.manufacturingYear.toString()
        dataState.price = action.payload.data.price.toString()
        dataState.pricingType = action.payload.data.pricingType
        dataState.seat = action.payload.data.seat.toString()
        dataState.shipGroup = action.payload.data.shipGroup
        dataState.shipOwner = action.payload.data.shipOwner
        dataState.shipType = action.payload.data.shipType
        dataState.shipbuildingSite = action.payload.data.shipbuildingSite
        dataState.sumFee =
          dataState.contractPackageType === 3 ? action.payload.data.sumFee.toString() : 0
        dataState.sumTax =
          dataState.contractPackageType === 3 ? action.payload.data.sumTax.toString() : 0
        dataState.amountShip = action.payload.data.amountShip.toString()
        dataState.material = action.payload.data.material
        dataState.grossTonnage = action.payload.data.grossTonnage?.toString()
        dataState.numberOfCrew = action.payload.data.numberOfCrew?.toString()
        dataState.shipName = action.payload.data.shipname
        dataState.imoShip = action.payload.data.imoShip
        dataState.callSign = action.payload.data.callSign
        dataState.shipLevel = action.payload.data.shipLevel
        dataState.pandiClub = action.payload.data.pandiClub
        dataState.pandiClubType = action.payload.data.pandiClubType
        dataState.pandiClubFee = action.payload.data.pandiClubFee?.toString()
        dataState.pandiClubRate = action.payload.data.pandiClubRate?.toString()
        dataState.priceShipShell = action.payload.data.priceShipShell?.toString()
        dataState.priceEquipment = action.payload.data.priceEquipment?.toString()
        dataState.priceEngine = action.payload.data.priceEngine.toString()
        dataState.shipRegistrationPort = action.payload.data.shipRegistrationPort
        dataState.startDate =
          action.payload.data.startDate != '01/01/0001'
            ? moment(action.payload.data.startDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
            : null
        dataState.expireDate =
          action.payload.data.expireDate != '01/01/0001'
            ? moment(action.payload.data.expireDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
            : null
      }
      return marineOfferFeeState
    case 'UPDATECURRENCYSTATE':
      const updateCurrencyState = JSON.parse(JSON.stringify(state))
      const updateCurrencyStateTab = updateCurrencyState.find(
        (o: any) => o.tabName == action.payload.tab
      )
      if (updateCurrencyStateTab) {
        updateCurrencyStateTab.form.formData[action.payload.form].curencyMoney =
          action.payload.currencyMoney
        updateCurrencyStateTab.form.formData[action.payload.form].exchangeRate =
          action.payload.exchangeRate
      }
      return updateCurrencyState
    case 'GETCONTRACTEXTRADATA':
      return state
    case 'SAVECONTRACTEXTRADATA':
      const extraDatatate = JSON.parse(JSON.stringify(state))
      if (!action.payload.data) return extraDatatate
      const extraDataTab = extraDatatate.find((o: any) => o.sellingContractId == action.payload.id)
      if (extraDataTab) {
        let dataState: any = extraDataTab.form.formData[action.payload.form]
        dataState[action.payload.key] = action.payload.data
      }
      return extraDatatate
    case 'GETLISTMARINEINSURED':
      return state
    case 'SAVELISTMARINEINSURED':
      const marineListState = JSON.parse(JSON.stringify(state))
      const marineListTab = marineListState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (marineListTab) {
        if (action.payload.data && action.payload.data.items) {
          marineListTab.form.formData.formMarineListInsured.listMarine = action.payload.data.items
          marineListTab.form.formData.formMarineListInsured.totalRows =
            action.payload.data.totalItems
        }
      }
      return marineListState
    case 'GETMARINEINSUREDBYID':
      return state
    case 'SAVEMARINEINSUREDINFO':
      const marineInfoState = JSON.parse(JSON.stringify(state))
      const marineInfoTab = marineInfoState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (marineInfoTab) {
        const dataForm = marineInfoTab.form.formData.formMarineListInsured
        dataForm.code = action.payload.data.packageCode
        dataForm.id = action.payload.data.id
        dataForm.sumFee = action.payload.data.sumFee?.toString()
        dataForm.sumTax = action.payload.data.sumTax?.toString()
        dataForm.totalFee = (action.payload.data.sumFee + action.payload.data.sumTax)?.toString()
        dataForm.startDate = moment(action.payload.data.startDate, 'DD/MM/YYYY HH:mm').format(
          'YYYY/MM/DD HH:mm'
        )
        dataForm.expireDate = moment(action.payload.data.expireDate, 'DD/MM/YYYY HH:mm').format(
          'YYYY/MM/DD HH:mm'
        )
        dataForm.shipOwner = action.payload.data._sellingContractMarineDtos[0].shipOwner
        dataForm.shipName = action.payload.data._sellingContractMarineDtos[0].shipname
        dataForm.shipGroup = action.payload.data._sellingContractMarineDtos[0].shipGroup
        dataForm.shipType = action.payload.data._sellingContractMarineDtos[0].shipType
        dataForm.manufacturingYear =
          action.payload.data._sellingContractMarineDtos[0].manufacturingYear?.toString()
        dataForm.shipbuildingSite =
          action.payload.data._sellingContractMarineDtos[0].shipbuildingSite
        dataForm.shipRegistrationPort =
          action.payload.data._sellingContractMarineDtos[0].shipRegistrationPort
        dataForm.deadweightTonnage =
          action.payload.data._sellingContractMarineDtos[0].deadweightTonnage.toString()
        dataForm.engineCapacity =
          action.payload.data._sellingContractMarineDtos[0].engineCapacity?.toString()
        dataForm.seat = action.payload.data._sellingContractMarineDtos[0].seat?.toString()
        dataForm.tradingLimit = action.payload.data._sellingContractMarineDtos[0].tradingLimit
        dataForm.nationality = action.payload.data._sellingContractMarineDtos[0].nationality
        dataForm.imoShip = action.payload.data._sellingContractMarineDtos[0].imoShip
        dataForm.shipLevel = action.payload.data._sellingContractMarineDtos[0].shipLevel
        dataForm.pandiClub = action.payload.data._sellingContractMarineDtos[0].pandiClub
        dataForm.pandiClubType = action.payload.data._sellingContractMarineDtos[0].pandiClubType
        dataForm.pandiClubFee =
          action.payload.data._sellingContractMarineDtos[0].pandiClubFee?.toString()
        dataForm.pandiClubRate =
          action.payload.data._sellingContractMarineDtos[0].pandiClubRate?.toString()
        dataForm.priceShipShell =
          action.payload.data._sellingContractMarineDtos[0].priceShipShell?.toString()
        dataForm.priceEquipment =
          action.payload.data._sellingContractMarineDtos[0].priceEquipment?.toString()
        dataForm.priceEngine =
          action.payload.data._sellingContractMarineDtos[0].priceEngine?.toString()
        dataForm.price = action.payload.data._sellingContractMarineDtos[0].price?.toString()
        dataForm.material = action.payload.data._sellingContractMarineDtos[0].material
        dataForm.pricingType = action.payload.data._sellingContractMarineDtos[0].pricingType
        dataForm.callSign = action.payload.data._sellingContractMarineDtos[0].callSign
        dataForm.grossTonnage = action.payload.data._sellingContractMarineDtos[0].grossTonnage
        dataForm.numberOfCrew = action.payload.data._sellingContractMarineDtos[0].numberOfCrew
        dataForm._sellingContractMarineBenefitDtos =
          action.payload.data._sellingContractMarineBenefitDtos
        dataForm._sellingContractMarineExtensionDtos =
          action.payload.data._sellingContractMarineExtensionDtos
        dataForm._sellingContractMarineDeductibleDtos =
          action.payload.data._sellingContractMarineDeductibleDtos
        dataForm.updateCaculator = true
      }
      return marineInfoState

    case 'GETLISTLOCALINSURED':
      return state
    case 'SAVELISTLOCALINSURED':
      const locaListState = JSON.parse(JSON.stringify(state))
      const locaListTab = locaListState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (locaListTab) {
        if (action.payload.data && action.payload.data.items) {
          locaListTab.form.formData[action.payload.form].listLocaltion = action.payload.data.items
          locaListTab.form.formData[action.payload.form].totalRows = action.payload.data.totalItems
        }
      }
      return locaListState
    case 'GETLISTMICROINSURED':
      return state
    case 'SAVELISTMICROINSURED':
      const microListState = JSON.parse(JSON.stringify(state))
      const microListTab = microListState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (microListTab) {
        if (action.payload.data && action.payload.data.items) {
          microListTab.form.formData.formMicroListInsured.listMicro = action.payload.data.items
          microListTab.form.formData.formMicroListInsured.totalRows = action.payload.data.totalItems
        }
      }
      return microListState
    case 'GETDATAFORMMICROOFFERFEEBYCODE':
      return state
    case 'SAVEDATAFORMMICROOFFERFEE':
      const microOfferFeeState = JSON.parse(JSON.stringify(state))
      const microOfferFeeTab = microOfferFeeState.find(
        (o: any) => o.sellingContractId == action.payload.data.sellingContractId
      )

      if (microOfferFeeTab) {
        let dataState: any = microOfferFeeTab.form.formData[action.payload.form]
        if (action.payload.form === 'formMicroOfferFee') {
          dataState.id = action.payload.data.id
          dataState.packageCode = action.payload.data.packageCode
          dataState.code = action.payload.data.code
          dataState.address = action.payload.data.address
          dataState.name = action.payload.data.name
          dataState.nameInsured = action.payload.data.nameInsured
          dataState.indentifyNumber = action.payload.data.indentifyNumber
          dataState.addressInsured = action.payload.data.addressInsured
          dataState.characteristic = action.payload.data.characteristic
          dataState.phoneNumber = action.payload.data.phoneNumber
          dataState.sellingContractId = action.payload.data.sellingContractId
          dataState.filter = action.payload.data.filter
          dataState.startDate = moment(action.payload.data.startDate, 'DD/MM/YYYY').format(
            'YYYY/MM/DD'
          )
          dataState.expireDate = moment(action.payload.data.expireDate, 'DD/MM/YYYY').format(
            'YYYY/MM/DD'
          )
          // get benefit from packageInsurance
          let dataBenefit = microOfferFeeTab.packageInsurance.find((o: any) =>
            dataState.packageCode.includes(o.code)
          )?.microPackageBenefitsDto

          // clear checkBox benefit
          dataState.sellingContractMicroBenefitPackage = []
          dataBenefit.map((o: any) => {
            dataState.sellingContractMicroBenefitPackage.push({
              id: o.id,
              benefitCode: o.benefitCode,
              benefitName: o.benefitName,
              ordinalNumbers: o.ordinalNumbers,
              startDate: o.startDate,
              expireDate: o.expireDate,
              standardSumInsured: 0,
              standardRate: 0,
              standardInsuranceFee: 0,
              offerSumInsured: 0,
              offerRate: 0,
              offerInsuranceFee: 0,
              offerDiscountRate: 0,
              offerInsuranceFeeOriginal: 0,
              offerTax: 0,
              approveSumInsured: 0,
              approveRate: 0,
              approveInsuranceFee: 0,
              approveDiscountRate: 0,
              approveInsuranceFeeOriginal: 0,
              approveTax: 0,
              insuranceClauseType: '',
              isChecked: false,
              checkboxF: false,
              isRequired: o.isRequired ? o.isRequired : false,
            })
          })
          // add benefit
          action.payload.data._sellingContractMicroBenefitPackage.forEach((o: any) => {
            let index = dataState.sellingContractMicroBenefitPackage.findIndex(
              (ele: any) => ele.benefitCode == o.benefitCode
            )
            let checkRequired = dataState.sellingContractMicroBenefitPackage.findIndex(
              (ele: any) => ele.benefitCode == o.benefitCode && ele.isRequired === true
            )
            if (index !== -1 && checkRequired === -1) {
              dataState.sellingContractMicroBenefitPackage[index] = {
                ...o,
                id: dataState.sellingContractMicroBenefitPackage[index].id,
              }
              dataState.sellingContractMicroBenefitPackage[index].isChecked = true
              dataState.sellingContractMicroBenefitPackage[index].checkboxF = true
            } else if (index !== -1 && checkRequired !== -1) {
              dataState.sellingContractMicroBenefitPackage[index] = {
                ...o,
                id: dataState.sellingContractMicroBenefitPackage[index].id,
              }
              dataState.sellingContractMicroBenefitPackage[index].isChecked = true
              dataState.sellingContractMicroBenefitPackage[index].checkboxF = true
              dataState.sellingContractMicroBenefitPackage[index].isRequired = true
            }
          })

          dataState.sellingContractMicroBenefitPackage.forEach((o: any) => {
            if (o.startDate != '01/01/0001') {
              o.startDate = moment(o.startDate, 'DD/MM/YYYY').toDate()
            }
            if (o.expireDate != '01/01/0001') {
              o.expireDate = moment(o.expireDate, 'DD/MM/YYYY').toDate()
            }
            if (action.payload.data.contractPackageType !== 3) {
              o.approveSumInsured = 0
              o.approveRate = 0
              o.approveInsuranceFee = 0
              o.approveDiscountRate = 0
              o.approveInsuranceFeeOriginal = 0
              o.approveTax = 0
            }
            o.insuranceClauseType = ''
          })

          // add extension
          dataState.sellingContractMicroExtensionPackage =
            action.payload.data._sellingContractMicroExtensionPackage

          // add deductibles
          dataState.sellingContractMicroDeductiblePackage =
            action.payload.data._sellingContractMicroDeductiblePackage
          // add deductibles
          dataState.sellingContractMicroDeductiblePackage =
            action.payload.data._sellingContractMicroDeductiblePackage.map((o: any) => ({
              id: o.id,
              deductibleRate: o.offerLossRatio,
              minimumDeductible: o.offerMinimum,
              note: o.offerNote,
            }))

          //
          dataState.sellingContractMicroExtensionFieldPackage =
            action.payload.data._sellingContractMicroExtensionFieldPackage
        } else {
          dataState.code = action.payload.data.code
          dataState.name = action.payload.data.name
          dataState.address = action.payload.data.address
          dataState.characteristic = action.payload.data.characteristic
          dataState.nameInsured = action.payload.data.nameInsured
          dataState.addressInsured = action.payload.data.addressInsured
          dataState.phoneNumber = action.payload.data.phoneNumber
          dataState.indentifyNumber = action.payload.data.indentifyNumber
          dataState.startDate = moment(action.payload.data.startDate, 'DD/MM/YYYY').format(
            'YYYY/MM/DD'
          )
          dataState.expireDate = moment(action.payload.data.expireDate, 'DD/MM/YYYY').format(
            'YYYY/MM/DD'
          )
          dataState._sellingContractMicroBenefitPackage =
            action.payload.data._sellingContractMicroBenefitPackage
          dataState._sellingContractMicroExtensionPackage =
            action.payload.data._sellingContractMicroExtensionPackage
          dataState._sellingContractMicroDeductiblePackage =
            action.payload.data._sellingContractMicroDeductiblePackage
        }
      }
      return microOfferFeeState
    case 'GETMICROINSUREDBYID':
      return state
    case 'SAVEMICROINSUREDINFO':
      const microInfoState = JSON.parse(JSON.stringify(state))
      const microInfoTab = microInfoState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (microInfoTab) {
        const dataForm = microInfoTab.form.formData.formMicroListInsured
        dataForm.code = action.payload.data.packageCode
        dataForm.id = action.payload.data.id
        dataForm.sumFee = action.payload.data.sumFee
        dataForm.sumTax = action.payload.data.sumTax
        dataForm.startDate = moment(action.payload.data.startDate, 'DD/MM/YYYY HH:mm').format(
          'YYYY/MM/DD HH:mm'
        )
        dataForm.expireDate = moment(action.payload.data.expireDate, 'DD/MM/YYYY HH:mm').format(
          'YYYY/MM/DD HH:mm'
        )
        dataForm.address = action.payload.data._sellingContractMicro[0].address
        dataForm.addressInsured = action.payload.data._sellingContractMicro[0].addressInsured
        dataForm.characteristic = action.payload.data._sellingContractMicro[0].characteristic
        dataForm.indentifyNumber = action.payload.data._sellingContractMicro[0].indentifyNumber
        dataForm.name = action.payload.data._sellingContractMicro[0].name
        dataForm.nameInsured = action.payload.data._sellingContractMicro[0].nameInsured
        dataForm.phoneNumber = action.payload.data._sellingContractMicro[0].phoneNumber
        dataForm._sellingContractMicroBenefitPackage =
          action.payload.data._sellingContractMicroBenefits
        dataForm._sellingContractMicroExtensionPackage =
          action.payload.data._sellingContractMicroExtension
        dataForm._sellingContractMicroDeductiblePackage =
          action.payload.data._sellingContractMicroDeductibles
      }
      return microInfoState
    case 'GETLOCATIONINSUREDBYID':
      return state
    case 'SAVELOCATIONINSUREDINFO':
      const locaInfoState = JSON.parse(JSON.stringify(state))
      const locaInfoTab = locaInfoState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (locaInfoTab) {
        const dataForm: PropertyOfferFeeModel = locaInfoTab.form.formData[action.payload.form]
        const contractPropertyDtos = action.payload.data._sellingContractPropertyDtos[0]
        dataForm.id = action.payload.data.id
        dataForm.packageCode = contractPropertyDtos.packageCode
        dataForm.addressName = contractPropertyDtos.addressName
        dataForm.latitude = contractPropertyDtos.latitude
        dataForm.longitude = contractPropertyDtos.longitude
        dataForm.address = contractPropertyDtos.address
        dataForm.subDistrict = contractPropertyDtos.subDistrict
        dataForm.district = contractPropertyDtos.district
        dataForm.province = contractPropertyDtos.province
        dataForm.businessAreas = contractPropertyDtos.businessAreas
        dataForm.businessAreasName = contractPropertyDtos.businessAreasName
        dataForm.propertyBusinessCode = contractPropertyDtos.propertyBusinessCode
        dataForm.propertyBusinessName = contractPropertyDtos.propertyBusinessName
        dataForm.riskLevel = contractPropertyDtos.riskLevel
        dataForm.sumBusinessInterruptionInsured =
          contractPropertyDtos.sumBusinessInterruptionInsured
            ? formatter(contractPropertyDtos.sumBusinessInterruptionInsured)
            : '0'
        dataForm.sumFireExplosionInsured = contractPropertyDtos.sumFireExplosionInsured
          ? formatter(contractPropertyDtos.sumFireExplosionInsured)
          : '0'
        dataForm.sumMaterialInsured = contractPropertyDtos.sumMaterialInsured
          ? formatter(contractPropertyDtos.sumMaterialInsured)
          : '0'
        dataForm.expireDate = action.payload.data.expireDate
          ? moment(action.payload.data.expireDate, 'DD/MM/YYYY HH:mm').format('YYYY/MM/DD HH:mm')
          : null
        dataForm.startDate = action.payload.data.startDate
          ? moment(action.payload.data.startDate, 'DD/MM/YYYY HH:mm').format('YYYY/MM/DD HH:mm')
          : null
        dataForm.startActivity = contractPropertyDtos.startActivity
          ? moment(contractPropertyDtos.startActivity, 'DD/MM/YYYY HH:mm').format(
              'YYYY/MM/DD HH:mm'
            )
          : null
        dataForm.expireActivity = contractPropertyDtos.expireActivity
          ? moment(contractPropertyDtos.expireActivity, 'DD/MM/YYYY HH:mm').format(
              'YYYY/MM/DD HH:mm'
            )
          : null
        if (action.payload.form == 'formPropertyOfferFee') {
          dataForm.totalPrice = contractPropertyDtos.totalPrice
            ? formatter(contractPropertyDtos.totalPrice)
            : '0'
          dataForm.sumFee =
            contractPropertyDtos.contractPackageType == 3
              ? formatter(action.payload.data.sumFee)
              : '0'
          dataForm.sumTax =
            contractPropertyDtos.contractPackageType == 3
              ? formatter(action.payload.data.sumTax)
              : '0'
          dataForm.sumFeeOffer = action.payload.data.sumFee
            ? formatter(action.payload.data.sumFee)
            : '0'
          dataForm.sumTaxOffer = action.payload.data.sumTax
            ? formatter(action.payload.data.sumTax)
            : '0'
          dataForm.startExpireActivity =
            moment(contractPropertyDtos.startActivity, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY') +
            ' - ' +
            moment(contractPropertyDtos.expireActivity, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY')
        }

        let arrBusinessInterruption: ListPropertyPackageBusinessInterruptionModel = []
        action.payload.data._sellingContractPropertyBusinessInterruptionDtos.map((o: any) => {
          arrBusinessInterruption.push({
            id: o.id,
            businessInterruptionName: o.businessInterruptionName,
            sumInsured: o.sumInsured ? formatter(o.sumInsured) : '0',
            numberOfMonth: o.numberOfMonth ? formatter(o.numberOfMonth) : '0',
            note: o.note,
          })
        })
        dataForm._sellingContractPropertyBusinessInterruptionDto = arrBusinessInterruption

        let arrRisk: ListPropertyPackageRiskModel = []
        action.payload.data._sellingContractPropertyRiskDtos.map((o: any) => {
          arrRisk.push({
            id: o.id,
            riskName: o.riskName,
            propertyType: o.propertyType,
            assetValuation: o.assetValuation,
            amount: o.amount ? formatter(o.amount) : '0',
            price: o.price ? formatter(o.price) : '0',
            unit: o.unit ? o.unit : '',
            curencyMoney: action.payload.data.curencyMoney,
            totalPrice: o.totalPrice ? formatter(o.totalPrice) : '0',
            note: o.note,
          })
        })
        dataForm._sellingContractPropertyRiskDto = arrRisk

        let arrBenefit: ListPropertyPackageBenefitModel = []
        action.payload.data._sellingContractPropertyBenefitDtos.map((o: any) => {
          arrBenefit.push({
            id: o.id,
            benefitName: o.benefitName,
            benefitCode: o.benefitCode,
            conditionParticipation: o.conditionParticipation,
            conditionParticipationName: o.conditionParticipationName,
            ordinalNumbers: o.ordinalNumbers,
            startDate: o.startDate,
            expireDate: o.expireDate,
            standardSumInsured: o.sumInsured,
            standardRate: o.standardRate,
            standardInsuranceFee: o.standardInsuranceFee,
            offerSumInsured: o.sumInsured,
            offerRate: o.offerRate,
            offerInsuranceFee: o.offerInsuranceFee,
            offerDiscountRate: o.offerDiscountRate,
            offerInsuranceFeeOriginal: o.offerInsuranceFee,
            offerTax: o.offerTax,
            approveSumInsured: contractPropertyDtos.contractPackageType == 3 ? o.sumInsured : 0,
            approveRate: contractPropertyDtos.contractPackageType == 3 ? o.approveRate : 0,
            approveInsuranceFee:
              contractPropertyDtos.contractPackageType == 3 ? o.approveInsuranceFee : 0,
            approveDiscountRate:
              contractPropertyDtos.contractPackageType == 3 ? o.approveDiscountRate : 0,
            approveInsuranceFeeOriginal:
              contractPropertyDtos.contractPackageType == 3 ? o.approveInsuranceFee : 0,
            approveTax: contractPropertyDtos.contractPackageType == 3 ? o.approveTax : 0,
            listConditionParticipation: [],
            checkboxF: o.isChecked,
            isChecked: o.isChecked,
            isRequired: o.isRequired,
          })
        })
        dataForm._sellingContractPropertyBenefitDtos = arrBenefit

        let arrExtension: ListPropertyPackageExtensionModel = []
        action.payload.data._sellingContractPropertyExtensionDtos.map((o: any) => {
          arrExtension.push({
            id: o.id,
            extensionName: o.extensionName,
            extensionCode: o.extensionCode,
            startDate: o.startDate,
            expireDate: o.expireDate,
            isRequired: o.isRequired,
            isChecked: o.isChecked,
          })
        })
        dataForm._sellingContractPropertyExtensionDto = arrExtension

        // let arrDeductible: ListMarinePackageDeductibleModel = []
        // action.payload.data._sellingContractPropertyDeductibleDtos.map((o: any) => {
        //   arrDeductible.push({
        //     id: o.id,
        //     ordinalNumbers: o.ordinalNumbers,
        //     startDate: o.startDate,
        //     expireDate: o.expireDate,
        //     offerNote: o.note,
        //     offerLossRatio: o.lossRatio,
        //     offerMinimum: o.minimum,
        //     approveLossRatio: o.lossRatio,
        //     approveMinimum: o.minimum,
        //     approveNote: o.note,
        //   })
        // })

        dataForm._sellingContractPropertyDeductibleDto =
          action.payload.data._sellingContractPropertyDeductibleDtos.map((o: any) => ({
            id: o.id,
            deductibleRate: o.lossRatio,
            minimumDeductible: o.minimum,
            note: o.note,
          }))

        dataForm.callBenefitDetail = action.payload.callBenefitDetail
        dataForm.callCaculator = action.payload.callCaCulator
      }

      return locaInfoState

    case 'UPDATEPROPERTYINSUREDID': {
      const propertyUpdateIdState = JSON.parse(JSON.stringify(state))
      const propertyUpdateIdTab = propertyUpdateIdState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (propertyUpdateIdTab) {
        let dataForm = propertyUpdateIdTab.form.formData[action.payload.form]
        // add id obj
        dataForm.id = action.payload.data.id

        if ((action.payload.form = 'formPropertyOfferFee')) {
          // add id benefit
          let benefit = action.payload.data._sellingContractPropertyBenefitDtos
          if (benefit.length) {
            benefit.forEach((o: PropertyPackageBenefitModel) => {
              let index = dataForm._sellingContractPropertyBenefitDtos.findIndex(
                (ele: PropertyPackageBenefitModel) => ele.benefitCode === o.benefitCode
              )
              if (index !== -1) {
                dataForm._sellingContractPropertyBenefitDtos[index].id = o.id
              }
            })
          }
          // add id extension
          let extension = action.payload.data._sellingContractPropertyExtensionDtos
          if (extension.length) {
            extension.forEach((o: PropertyPackageExtensionModel) => {
              let index = dataForm._sellingContractPropertyExtensionDto.findIndex(
                (ele: PropertyPackageExtensionModel) => ele.extensionCode === o.extensionCode
              )
              if (index != -1) {
                dataForm._sellingContractPropertyExtensionDto[index].id = o.id
              }
            })
          }
          //add id deductible
          let deductible = action.payload.data._sellingContractPropertyDeductibleDtos
          if (deductible.length) {
            deductible.forEach((o: any) => {
              let index = dataForm._sellingContractPropertyDeductibleDto.findIndex(
                (ele: any) => ele.deductibleRate === o.lossRatio
              )
              if (index != -1) {
                dataForm._sellingContractPropertyDeductibleDto[index].id = o.id
              }
            })
          }
        }
      }
      return propertyUpdateIdState
    }
    case 'SAVELISTRISKBENFITDETAIL': {
      const riskBenefitState = JSON.parse(JSON.stringify(state))
      const riskBenefitTab = riskBenefitState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (riskBenefitTab) {
        let dataForm = riskBenefitTab.form.formData.formPropertyOfferFee
        let dataListRiskBenefit: ListPropertyPackageRiskBenefitDto = action.payload.data
        let dataRiskBenefit: ListPropertyPackageRiskBenefitModel = []
        dataListRiskBenefit.map((o: PropertyPackageRiskBenefitDto, i: number) => {
          dataRiskBenefit.push({
            id: o.id ? o.id : i,
            sellingContractObjectInsuredId: o.sellingContractObjectInsuredId,
            benefitCode: o.benefitCode,
            riskName: o.riskName,
            amount: o.amount ? formatter(o.amount) : '0',
            unit: o.unit,
            totalPrice: o.totalPrice ? formatter(o.totalPrice) : '0',
            sumInsured: o.sumInsured ? formatter(o.sumInsured) : '0',
            curencyMoney: '',
          })
        })

        dataForm._sellingContractPropertyRiskBenefitDtos = dataRiskBenefit
        dataForm.callBenefitDetail = false
      }
      return riskBenefitState
    }
    case 'GETLISTTECHNICALINSURED':
      return state
    case 'SAVELISTTECHNICALINSURED':
      const technicalListState = JSON.parse(JSON.stringify(state))
      const technicalListTab = technicalListState.find(
        (o: any) => o.sellingContractId == action.payload.sellingContractId
      )
      if (technicalListTab) {
        if (action.payload.data && action.payload.data.items) {
          technicalListTab.form.formData[action.payload.form].listTechnical =
            action.payload.data.items
          technicalListTab.form.formData[action.payload.form].totalRows =
            action.payload.data.totalItems
        }
      }
      return technicalListState
    default:
      return state
  }
}

export function* saga() {
  yield takeLatest('GETLISTHOUSEINSURED', function* getListHouseInsuredSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(getListHouseInsured, action.payload)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveListHouseInsured(param))
      }
    } catch (error) {
      return
    }
  })

  yield takeLatest('GETHOUSEINSUREDBYID', function* getHouseInsuredByID(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(getHouseInsuredById, action.payload)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveHouseInsured(param))
      }
    } catch (error) {
      return
    }
  })

  yield takeLatest(
    'GETHOUSECONTRACTSTEP4BYID',
    function* getHouseContractStep4ByIdSaga(action: any) {
      try {
        //@ts-ignore
        const response: any = yield call(step4GetContractByID, action.payload)
        if (response && !response.isError) {
          yield put(actions.saveHouseContractStep4ById(response.data))
        }
      } catch (error) {
        return
      }
    }
  )

  yield takeLatest(
    'GETDATAFORMCARGOOFFERFEEBYCODE',
    function* getDataFormCargoOfferFeeByCodeSaga(action: any) {
      try {
        //@ts-ignore
        const response: any = yield call(step2GetContractPackageCargoByCode, action.payload)
        if (response && !response.isError) {
          yield put(actions.saveDataFormCargoOfferFee(response.data))
        }
      } catch (error) {
        return
      }
    }
  )
  yield takeLatest(
    'GETDATAFORMCARGOADDITIONALBYID',
    function* getDataFormCargoAdditionalByIdSaga(action: any) {
      try {
        //@ts-ignore
        const response: any = yield call(step4GetObjectInsuredById, action.payload)
        if (response && !response.isError) {
          yield put(actions.saveDataFormCargoAdditional(response.data))
        }
      } catch (error) {
        return
      }
    }
  )
  yield takeLatest(
    'GETDATAFORMMARINEOFFERFEEBYCODE',
    function* getDataFormCargoOfferFeeByCodeSaga(action: any) {
      try {
        //@ts-ignore
        const response: any = yield call(step2GetContractPackageMarineByCode, action.payload)
        if (response && !response.isError) {
          yield put(
            actions.saveDataFormMarineOfferFee({data: response.data, form: action.payload.form})
          )
        }
      } catch (error) {
        return
      }
    }
  )
  yield takeLatest('GETCONTRACTEXTRADATA', function* getContractExtraDataSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step2GetContractExtraData, action.payload.id)
      if (response && !response.isError) {
        const paymentTimeDay = response.data.find((o: any) => o.name == 'NGAY_THANH_TOAN')
        if (paymentTimeDay && action.payload.form === 'formProductInsurancePlan') {
          yield put(
            actions.saveContractExtraData({
              data: paymentTimeDay,
              key: 'paymentTimeDay',
              form: action.payload.form,
              id: paymentTimeDay.sellingContractId,
            })
          )
        }
        const packageCodeOriginal = response.data.find((o: any) => o.name == 'GOI_BAO_HIEM_GOC')
        if (packageCodeOriginal) {
          if (action.payload.form === 'formProductInsurancePlan') {
            yield put(
              actions.saveContractExtraData({
                data: packageCodeOriginal,
                key: 'packageCodeOriginal',
                id: packageCodeOriginal.sellingContractId,
                form: action.payload.form,
              })
            )
          }
          if (action.payload.form === 'formPropertyLocation') {
            yield put(
              actions.saveContractExtraData({
                data: packageCodeOriginal.describe,
                id: packageCodeOriginal.sellingContractId,
                key: 'packageCode',
                form: action.payload.form,
              })
            )
          }
        }
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETLISTMARINEINSURED', function* getListMarineInsuredSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredMarineList, action.payload)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveListMarineInsured(param))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETMARINEINSUREDBYID', function* getMarineInsuredByID(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredMarineByID, action.payload)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveMarineInsuredInfo(param))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETLISTLOCALINSURED', function* getListLocalInsuredSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step2GetObjectInsuredPropertyList, action.payload.data)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.data.sellingContractId,
          data: response.data,
          form: action.payload.form,
        }
        yield put(actions.saveListLocalInsured(param))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETLISTMICROINSURED', function* getListMicroInsuredSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredMicroList, action.payload)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveListMicroInsured(param))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest(
    'GETDATAFORMMICROOFFERFEEBYCODE',
    function* getDataFormMicroOfferFeeByCodeSaga(action: any) {
      try {
        //@ts-ignore
        const response: any = yield call(step2GetContractPackageMicroByCode, action.payload)
        if (response && !response.isError) {
          yield put(
            actions.saveDataFormMicroOfferFee({data: response.data, form: action.payload.form})
          )
        }
      } catch (error) {
        return
      }
    }
  )
  yield takeLatest('GETLOCATIONINSUREDBYID', function* getLocationInsuredByID(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step2GetObjectInsuredLocationByID, action.payload)
      if (response && !response.isError) {
        let param: any = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
          form: action.payload.form,
          callCaCulator: action.payload.callCaculator ? action.payload.callCaculator : false,
          callBenefitDetail: action.payload.callBenefitDetail
            ? action.payload.callBenefitDetail
            : false,
        }
        yield put(actions.saveLocationInsuredInfo(param))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETLISTTECHNICALINSURED', function* getListTechnicalInsuredSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step2GetObjectInsuredPropertyList, action.payload.data)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.data.sellingContractId,
          data: response.data,
          form: action.payload.form,
        }
        yield put(actions.saveListTechnicalInsured(param))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETMICROINSUREDBYID', function* getMicroInsuredByID(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(step3GetObjectInsuredMicroByID, action.payload)
      if (response && !response.isError) {
        let param = {
          sellingContractId: action.payload.sellingContractId,
          data: response.data,
        }
        yield put(actions.saveMicroInsuredInfo(param))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETPROPERTYLISTCONTRACT', function* getPropertyListContractSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(getListContractByAddress, action.payload.data)
      if (response && !response.isError) {
        let param = {
          form: action.payload.form,
          data: response.data,
          sellingContractId: action.payload.sellingContractId,
        }
        yield put(actions.savePropertyListContract(param))
      }
    } catch (error) {
      return
    }
  })
}
